// extracted by mini-css-extract-plugin
export var header = "_52-0";